export default "__VITE_ASSET__955bb049__"